<div class="contract-container">
  <div class="bg-white rounded">
    <div class="row mx-0 contracts-sign__body pb-0">
      <h4
        class="mb-4"
        id="contract-title"
        [innerHTML]="contract?.content_transformed.title"></h4>
      <div class="position-relative" id="contract-body-container">
        <div
          id="bodyContract"
          class="contract-paragraph contract-text"
          [innerHtml]="sanitizeInnerHtml(contract?.content_transformed.content)"
          #scrollContainer
          (scroll)="onScroll($event)"></div>
        <div
          *ngIf="shouldShowBanner"
          class="d-flex justify-content-center info-card position-sticky mx-0 mx-md-4 cursor-pointer"
          style="line-height: 1.5rem"
          id="contract-scroll-banner"
          [@inOutAnimation]
          (click)="scrollToBottom()">
          <span cdkIcon="outlined">keyboard_double_arrow_down</span>You must
          scroll through the entire terms of the agreement before you can agree
        </div>
      </div>
    </div>
    <div class="user-actions contracts">
      <div class="row contracts-sign__form-actions">
        <div class="d-flex flex-column-reverse flex-md-row gap-3">
          <div class="pe-0 pe-sm-5 col-md-4 d-block" *ngIf="!noDisclaimer">
            <div
              *ngIf="contract?.text_component.length"
              class="d-flex disclaimer gap-2">
              <span class="info-icon"
                ><span cdkIcon="outlined">info</span></span
              >
              <span>{{ contract?.text_component }}</span>
            </div>
          </div>

          <div class="col-12" [class.col-md-8]="!noDisclaimer">
            <ng-container
              *ngIf="componentName; else notFound"
              [ngComponentOutlet]="componentMap[componentName]"></ng-container>
            <ng-template #notFound>
              <div class="d-flex justify-content-center">
                Formulario no encontrado.
              </div>
            </ng-template>
          </div>
        </div>

        <div
          class="d-flex flex-column flex-sm-row justify-content-end p-0 m-0 mt-4 contracts-sign__user-actions">
          <div class="col-12 col-sm-3">
            <button
              type="button"
              class="mt-2 mt-sm-0 me-0 me-sm-5 w-100 btn-skip-to-home"
              cdkButton
              [outline]="true"
              id="skip-to-home"
              *ngIf="isAsr && isShowSkip"
              (click)="skipToHome()">
              Skip to Home
            </button>
          </div>
          <div
            class="d-flex flex-column-reverse flex-sm-row justify-content-end contracts__button-actions col-12 col-sm-9">
            <button
              type="button"
              class="mt-2 mt-sm-0 me-0 me-sm-5"
              cdkButton="dark"
              [outline]="true"
              id="decline-contract"
              *ngIf="decline"
              (click)="declineContract()">
              I decline
            </button>
            <button
              type="submit"
              cdkButton
              [disabled]="!validateForm() || shouldShowBanner || loading"
              class="btn btn-next"
              id="agree-contract"
              (click)="submit()">
              I agree
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
